import throttle from 'lodash/throttle'

export const throttledPyroFormValidator = <T>(
  validate: (values: T) => Partial<{ [K in keyof T]: string }>,
): ((values: T) => Partial<{ [K in keyof T]: string }>) => {
  const handleValidate = throttle((values: T) => validate(values), 250)

  return (values: T) => handleValidate(values) || {}
}
